import React,{useEffect,useRef,useState} from 'react';
import './SlidePayment.css';

// Example breakdown — BCOIN price = $0.01 (≈ ₹1) so 10% of $10 = $1 = 100 BCOIN
var EXAMPLE_PKGS=[
  {price:10, bcCount:100,  bcUsd:1,  ut:9},
  {price:70, bcCount:700,  bcUsd:7,  ut:63},
  {price:450,bcCount:4500, bcUsd:45, ut:405},
];

export default function SlidePayment({slideNumber,totalSlides,pdfMode}){
  var canvasRef=useRef(null);
  var [phase,setPhase]=useState(pdfMode?6:0);
  var [activeOpt,setActiveOpt]=useState(0);

  useEffect(function(){
    var c=canvasRef.current;if(!c)return;var ctx=c.getContext('2d');
    var W=c.width=window.innerWidth,H=c.height=window.innerHeight,run=true;
    function onR(){W=c.width=window.innerWidth;H=c.height=window.innerHeight;}
    window.addEventListener('resize',onR);
    var fp=[];for(var i=0;i<50;i++)fp.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.12,vy:-0.04-Math.random()*0.16,sz:Math.random()*1.5+0.4,al:Math.random()*0.12+0.04,hue:[45,0,30,340][Math.floor(Math.random()*4)]});
    var lts=[];function spLt(){var sx=Math.random()*W,sy=Math.random()<0.5?0:H;var a=Math.atan2(H/2-sy+(Math.random()-0.5)*H*0.4,W/2-sx+(Math.random()-0.5)*W*0.4);var len=Math.min(W,H)*0.15;var pts=[{x:sx,y:sy}];var px=sx,py=sy;for(var ii=0;ii<6;ii++){px+=Math.cos(a)*(len/6)+(Math.random()-0.5)*22;py+=Math.sin(a)*(len/6)+(Math.random()-0.5)*22;pts.push({x:px,y:py});}lts.push({pts:pts,life:0,mx:14,c:Math.random()>0.5?'251,191,36':'165,42,58',w:0.65});}
    var T=0;function draw(){if(!run)return;T++;ctx.clearRect(0,0,W,H);
      ctx.strokeStyle='rgba(251,191,36,0.005)';ctx.lineWidth=0.3;
      for(var x=0;x<W;x+=58){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,H);ctx.stroke();}
      for(var y=0;y<H;y+=58){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();}
      for(var i=0;i<fp.length;i++){var p=fp[i];p.x+=p.vx;p.y+=p.vy;if(p.y<-20){p.y=H+20;p.x=Math.random()*W;}if(p.x<-20)p.x=W+20;if(p.x>W+20)p.x=-20;var fl=p.al+Math.sin(T*0.01+p.x)*0.03;ctx.beginPath();ctx.arc(p.x,p.y,p.sz,0,6.28);ctx.fillStyle='hsla('+p.hue+',85%,60%,'+Math.max(0,fl)+')';ctx.fill();}
      if(T%50<2)spLt();
      for(var i=lts.length-1;i>=0;i--){var l=lts[i];l.life++;if(l.life>l.mx){lts.splice(i,1);continue;}var a2=1-l.life/l.mx;ctx.beginPath();ctx.moveTo(l.pts[0].x,l.pts[0].y);for(var j=1;j<l.pts.length;j++)ctx.lineTo(l.pts[j].x+(Math.random()-0.5)*3,l.pts[j].y+(Math.random()-0.5)*3);ctx.strokeStyle='rgba('+l.c+','+(a2*0.13)+')';ctx.lineWidth=l.w;ctx.stroke();}
      requestAnimationFrame(draw);}
    draw();return function(){run=false;window.removeEventListener('resize',onR);};
  },[]);

  useEffect(function(){
    if(pdfMode)return;
    var t=[
      setTimeout(function(){setPhase(1);},200),
      setTimeout(function(){setPhase(2);},500),
      setTimeout(function(){setPhase(3);},950),
      setTimeout(function(){setPhase(4);},1500),
      setTimeout(function(){setPhase(5);},2100),
      setTimeout(function(){setPhase(6);},2700),
    ];
    return function(){t.forEach(clearTimeout);};
  },[]);

  // Auto-toggle between Option A and Option B
  useEffect(function(){
    if(phase<6)return;var running=true;
    var iv=setInterval(function(){if(running)setActiveOpt(function(o){return o===0?1:0;});},3000);
    return function(){running=false;clearInterval(iv);};
  },[phase]);

  return React.createElement('div',{className:'spay'},
    React.createElement('canvas',{ref:canvasRef,className:'spay__canvas'}),
    React.createElement('div',{className:'spay__flash'+(phase>=1?' fire':'')}),
    ['tl','tr','bl','br'].map(function(pos){
      return React.createElement('div',{key:pos,className:'spay__corner spay__corner--'+pos+(phase>=6?' show':'')},
        React.createElement('svg',{viewBox:'0 0 100 100',fill:'none'},
          React.createElement('path',{d:'M0 45V2H2V0H45',stroke:pos.includes('b')?'rgba(251,191,36,0.6)':'rgba(165,42,58,0.6)',strokeWidth:'1'}),
          React.createElement('circle',{cx:'2',cy:'2',r:'2.5',fill:pos.includes('b')?'rgba(251,191,36,0.5)':'rgba(165,42,58,0.5)'},
            React.createElement('animate',{attributeName:'r',values:'2;3.5;2',dur:'3s',repeatCount:'indefinite'}))));
    }),

    React.createElement('div',{className:'spay__content'},
      React.createElement('div',{className:'spay__label'+(phase>=2?' show':'')},
        String(slideNumber).padStart(2,'0')+' / '+String(totalSlides).padStart(2,'0')+' — PAYMENT METHODS'),

      React.createElement('h1',{className:'spay__title notranslate'+(phase>=3?' show':'')},
        'TWO ',React.createElement('span',{className:'spay__title-glow'},'PAYMENT WAYS')),
      React.createElement('p',{className:'spay__sub'+(phase>=4?' show':'')},
        'Every package activation accepts two flexible payment options — your choice, every time.'),
      React.createElement('div',{className:'spay__dv'+(phase>=4?' show':'')}),

      // Two option cards
      React.createElement('div',{className:'spay__options'+(phase>=5?' show':'')},

        // OPTION A — 10% BCoin + 90% USDT
        React.createElement('div',{className:'spay__opt spay__opt--a'+(activeOpt===0?' spay__opt--active':'')},
          React.createElement('div',{className:'spay__opt-tag'},'OPTION A'),
          React.createElement('div',{className:'spay__opt-headline notranslate'},
            React.createElement('span',{className:'spay__opt-bc'},'10% '),
            React.createElement('span',{className:'spay__opt-tk'},'BCOIN'),
            React.createElement('span',{className:'spay__opt-plus'},' + '),
            React.createElement('span',{className:'spay__opt-ut'},'90% '),
            React.createElement('span',{className:'spay__opt-tk'},'USDT')),
          // Split bar visual
          React.createElement('div',{className:'spay__bar'},
            React.createElement('div',{className:'spay__bar-bc',style:{width:'10%'}},
              React.createElement('span',{className:'spay__bar-lbl notranslate'},'10%')),
            React.createElement('div',{className:'spay__bar-ut',style:{width:'90%'}},
              React.createElement('span',{className:'spay__bar-lbl notranslate'},'90%'))),
          // Example table
          React.createElement('div',{className:'spay__ex'},
            React.createElement('div',{className:'spay__ex-hdr'},
              React.createElement('span',null,'Package'),
              React.createElement('span',null,'BCOIN (10%)'),
              React.createElement('span',null,'USDT (90%)')),
            EXAMPLE_PKGS.map(function(p,i){return React.createElement('div',{key:i,className:'spay__ex-row notranslate'},
              React.createElement('span',{className:'spay__ex-pkg'},'$'+p.price),
              React.createElement('span',{className:'spay__ex-bc'},p.bcCount.toLocaleString()+' BCOIN ($'+p.bcUsd+')'),
              React.createElement('span',{className:'spay__ex-ut'},'$'+p.ut+' USDT'));}))
        ),

        // VS divider
        React.createElement('div',{className:'spay__vs notranslate'},'OR'),

        // OPTION B — 100% USDT
        React.createElement('div',{className:'spay__opt spay__opt--b'+(activeOpt===1?' spay__opt--active':'')},
          React.createElement('div',{className:'spay__opt-tag'},'OPTION B'),
          React.createElement('div',{className:'spay__opt-headline notranslate'},
            React.createElement('span',{className:'spay__opt-ut'},'100% '),
            React.createElement('span',{className:'spay__opt-tk'},'USDT')),
          React.createElement('div',{className:'spay__bar'},
            React.createElement('div',{className:'spay__bar-ut',style:{width:'100%'}},
              React.createElement('span',{className:'spay__bar-lbl notranslate'},'100%'))),
          React.createElement('div',{className:'spay__ex'},
            React.createElement('div',{className:'spay__ex-hdr'},
              React.createElement('span',null,'Package'),
              React.createElement('span',null,'USDT (100%)'),
              React.createElement('span',null,'BCOIN')),
            EXAMPLE_PKGS.map(function(p,i){return React.createElement('div',{key:i,className:'spay__ex-row notranslate'},
              React.createElement('span',{className:'spay__ex-pkg'},'$'+p.price),
              React.createElement('span',{className:'spay__ex-ut'},'$'+p.price+' USDT'),
              React.createElement('span',{className:'spay__ex-bc spay__ex-bc--none'},'—'));}))
        )
      ),

      // BCoin price info
      React.createElement('div',{className:'spay__pricebox'+(phase>=6?' show':'')},
        React.createElement('div',{className:'spay__pricebox-icon'},'B'),
        React.createElement('div',{className:'spay__pricebox-body'},
          React.createElement('div',{className:'spay__pricebox-lbl'},'BCOIN FIXED PRICE'),
          React.createElement('div',{className:'spay__pricebox-val notranslate'},'1 BCOIN = $0.01 USDT  ',React.createElement('span',{className:'spay__pricebox-inr'},'(≈ ₹1)')),
          React.createElement('div',{className:'spay__pricebox-sub'},'Native BNFT ecosystem token — locked reference price for package activation. 100 BCOIN = $1 USDT.'))),

      React.createElement('div',{className:'spay__notes'+(phase>=6?' show':'')},
        React.createElement('div',{className:'spay__note'},
          React.createElement('span',{className:'spay__note-icon'},'✓'),
          React.createElement('span',null,'Choose either option per package — no restrictions, fully flexible')),
        React.createElement('div',{className:'spay__note'},
          React.createElement('span',{className:'spay__note-icon'},'✓'),
          React.createElement('span',null,'Multiple packages can be activated together in a single transaction')),
        React.createElement('div',{className:'spay__note spay__note--highlight'},
          React.createElement('span',{className:'spay__note-icon spay__note-icon--gold'},'★'),
          React.createElement('span',{className:'spay__note-txt--gold'},'Payments settle on BNB Smart Chain — verified, transparent, on-chain')))
    ),
    React.createElement('div',{className:'spay__bot'+(phase>=6?' show':'')},React.createElement('span',null,'bnft.live'))
  );
}
